import { createContext, useContext } from "react";

const MyContext = createContext({});
export const useMyContext = () => useContext(MyContext);

export const MyContextProvider = ({ value, children }) => {
  const parent = useMyContext();
  const mergedValue = { ...parent, ...value };

  return (
    <MyContext.Provider value={mergedValue}>{children}</MyContext.Provider>
  );
};
